import {
    Box,
    Grid,
    Typography,
    SxProps,
    Theme,
    Card,
    CardContent,
    CardActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CommonStyles } from "../styles/CommonStyles";
import ReinovaButton from "../components/ReinovaButton";
import careersHeaderImg from "../assets/careers-header.webp";
import careersHeaderMobileImg from "../assets/careers-header-mobile.webp";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import { useIsMobile } from "../hooks/useIsMobile";
import { useTranslation } from "react-i18next";

const CareersPageStyle: Record<string, SxProps<Theme>> = {
    captionTitle: {
        fontSize: "27px",
        textAlign: "left",
        marginBottom: "20px",
    },
    captionTitleMobile: {
        fontSize: "20px",
        textAlign: "center",
        fontWeight: "bold"
    },
    captionTextMobile: {
        fontSize: "18px",
        textAlign: "center",
        background: "#37314A",
        padding: "20px",
        borderRadius: "10px",
        marginTop: "20px",
    },
    captionText: {
        fontSize: "22px",
        textAlign: "left",
    },
    headerImage: (theme: Theme) => ({
        maxHeight: "200px",
        img: {
            width: "100%",
            height: "200px",
            objectFit: "cover",
            filter: `drop-shadow(-12px 12px ${theme.palette.secondary.main})`,
        },
    }),
    headerImageMobile: (theme: Theme) => ({
        height: "200px",
        width: "100%",
        img: {
            width: "100%",
            overflow: "hidden",
            filter: `drop-shadow(-3px 3px ${theme.palette.secondary.main})`,
        },
    }),
};

const CareersPage = () => {
    let navigate = useNavigate();
    const { isMobile } = useIsMobile();
    const { t } = useTranslation();

    return (
        <>
            <PageTitle>{t("menu.careers")}</PageTitle>
            <PageContent>
                <Grid container spacing={4} justifyContent={"center"}>
                    <Grid item md={12}>
                        <Box
                            sx={isMobile ? CareersPageStyle.headerImageMobile : CareersPageStyle.headerImage}
                        >
                            <img src={isMobile ? careersHeaderMobileImg : careersHeaderImg} alt="insegna reinova" />
                        </Box>
                    </Grid>
                    <Grid item md={8} spacing={3}>
                        <Typography sx={ isMobile ? CareersPageStyle.captionTextMobile : CareersPageStyle.captionText }>
                            {t("careers.1")}
                        </Typography>
                        <Typography sx={ isMobile ? CareersPageStyle.captionTextMobile : CareersPageStyle.captionText }>
                            {t("careers.2")}
                        </Typography>
                        <Typography sx={ isMobile ? CareersPageStyle.captionTextMobile : CareersPageStyle.captionText }>
                            {t("careers.3")}
                        </Typography>
                        <Typography sx={ isMobile ? CareersPageStyle.captionTextMobile : CareersPageStyle.captionText }>
                            {t("careers.4")}
                        </Typography>
                        <Typography sx={ isMobile ? CareersPageStyle.captionTextMobile : CareersPageStyle.captionText }>
                            {t("careers.5")}
                        </Typography>
                    </Grid>

                    <Grid item md={4}>
                        <Card
                            sx={
                                isMobile
                                    ? CommonStyles.cardContainerMobile
                                    : CommonStyles.cardContainer
                            }
                        >
                            <CardContent>
                                <Typography
                                    sx={[ isMobile ? CommonStyles.cardTitleMobile : CommonStyles.cardTitle,
                                        { textAlign: "center" },
                                    ].flat(2)}
                                >
                                    {t("careers.6")}
                                </Typography>
                            </CardContent>
                            <CardActions
                                sx={{ alignItems: "center", justifyContent: "space-around" }}
                            >
                                {/* <ReinovaButton href={"https://www.linkedin.com/company/reinova-tech/jobs/"}> */}
                                <ReinovaButton onClick={() => navigate("positions")} style={{height: "auto"}}>
                                    {t("careers.7button")}
                                </ReinovaButton>
                                <ReinovaButton onClick={() => {window.location.assign((t("careers.mailto")).toString())}} style={{height: "auto"}}>
                                    {t("careers.spontbutton")}
                                </ReinovaButton>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </PageContent>
        </>
    );
};

export default CareersPage;
